import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plane",
  "use": "icon-plane-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-plane\">\n    <g data-name=\"_Icons / Plane\" style=\"opacity:.6\">\n        <path data-name=\"Path 2\" d=\"M0 16.5V12a2.347 2.347 0 0 1 .214-.895A2.531 2.531 0 0 1 1 10.587L10.5 9 1 7.413a3.244 3.244 0 0 1-.789-.571A2.3 2.3 0 0 1 0 6V1.5A1.5 1.5 0 0 1 2.274.215l15.269 8.094a.75.75 0 0 1 0 1.381L2.274 17.785A1.5 1.5 0 0 1 0 16.5z\" style=\"fill:#fff\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol